const Footer = () => {
    return (
        <div className='h-[200px] w-full'></div>
    )
}

export default Footer